import {log, merge, pipe, tap} from '@logistics-frontend/utils'

import type {Order as FormValues} from 'src/shared/types'
import {BUSINESS_VERTICALS} from 'src/widgets/VerticalsDeprecated/consts'

export function withTariff(tariff: string) {
  const partialValues = {
    isBusiness: BUSINESS_VERTICALS.includes(tariff),
    offerFlow: {
      vertical: {
        name: tariff,
      },
    },
  }

  return function _withTariff(values: FormValues): FormValues {
    return pipe(
      partialValues,
      tap(log('Стейт вертикали в урле')),
      merge(values),
      tap(log('Стейт формы после мерджа с урлом')),
    )
  }
}
